import { ComputedReferenceNodeModel } from "@/models/nodes/ComputedReferenceNodeModel";

import type { ComputedCommand } from "@/components/suggestions/types";
import type { DocumentModel } from "@/models/DocumentModel";

/**
 * Run a context-menu command against the selected computed node. Unwrapping
 * removes the node the selection points at, so the selection is dropped with it.
 */
export function executeComputedCommand(command: ComputedCommand, doc: DocumentModel): void {
  const node = doc.computedNodes.selectedComputedNode;
  if (!node) return;

  if (command === "go-to-source") {
    if (node.is(ComputedReferenceNodeModel)) {
      doc.computedNodes.goToSource(node);
    }
    return;
  }

  if (!doc.computedNodes.unlinkComputedNode(node)) return;

  doc.selection.resetSelection();
}
